"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BannerList = void 0;
const lodash_1 = require("lodash");
const react_1 = __importDefault(require("react"));
const react_query_1 = require("react-query");
const react_redux_1 = require("react-redux");
const common_1 = require("../../../common");
const banner_1 = require("../../../server/banner");
const classes_1 = require("../../../server/classes");
const account_1 = require("../../base/account");
const DeletePopUpLayout_1 = require("../../base/layout/DeletePopUpLayout");
const popup_1 = require("../../base/popup");
const BannerPreview_1 = require("./BannerPreview");
const types_1 = require("./types");
const PAGE_SIZE = 10;
const openBannerEditor = (showDepth, props) => {
    APP.eventManager.publish('CHANGE_MENU', { showDepth, props });
};
const confirmDeleteBanner = (title, content, onDelete) => {
    APP.eventManager.publish(popup_1.TOGGLE_POPUP, {
        component: DeletePopUpLayout_1.DeletePopUpLayout,
        componentProps: {
            deleteContent: [content],
            onDelete,
        },
        width: 639,
        title,
        isFit: true,
    });
};
/**
 * 전체(기본) 배너 카드 — 개별 설정이 없는 모든 클래스에 노출되는 배너.
 * 서버 GET 은 빈 class_id 를 404 로 거절하므로 전체 배너를 직접 읽을 수 없다. 대신 클래스 표가 받은
 * 응답 중 "전체 배너 적용"(result.class_id === '') 인 것을 테넌트별로 모아 보여준다.
 */
const GlobalBannerCard = react_1.default.memo(({ summary, showTenant, loading, fallbackTenantId, onChanged, }) => {
    const deleteMutation = (0, react_query_1.useMutation)(banner_1.deleteBanner);
    const banner = summary?.banner;
    // 전체 배너 설정/삭제는 X-Tenant-ID 필수(서버 2026-09-21 수정) — 유도된 테넌트, 없으면 관리자 자신의 테넌트
    const tenantId = summary?.tenantId || fallbackTenantId || '';
    const handlerEdit = () => {
        openBannerEditor(banner ? 'modify' : 'regist', {
            class_id: banner_1.GLOBAL_BANNER_CLASS_ID,
            class_title: '전체',
            tenant_id: tenantId || undefined,
            isNew: !banner,
            // 목록이 판정한 값을 그대로 넘긴다(undefined 면 편집 화면이 클래스 조회로 다시 유도)
            initialBanner: banner,
        });
    };
    const handlerDelete = () => {
        confirmDeleteBanner('전체 배너 삭제', '전체 배너를 삭제하시겠습니까?\n개별 설정이 없는 클래스에서는 배너가 사라집니다.', async () => {
            APP.eventManager.publish('SHOW_LOADING', true);
            try {
                await deleteMutation.mutateAsync({
                    class_id: banner_1.GLOBAL_BANNER_CLASS_ID,
                    tenant_id: tenantId || undefined,
                });
                onChanged();
            }
            catch (err) {
                alert(err);
            }
            finally {
                APP.eventManager.publish('SHOW_LOADING', false);
            }
        });
    };
    const renderBody = () => {
        if (loading && banner === undefined) {
            return react_1.default.createElement("p", { className: "banner-empty" }, "\uBD88\uB7EC\uC624\uB294 \uC911...");
        }
        if (!summary) {
            return (react_1.default.createElement("p", { className: "banner-empty" }, "\uD074\uB798\uC2A4\uAC00 \uC5C6\uC5B4 \uC804\uCCB4 \uBC30\uB108\uB97C \uD655\uC778\uD560 \uC218 \uC5C6\uC2B5\uB2C8\uB2E4. \uAC80\uC0C9 \uC870\uAC74\uC744 \uBC14\uAFB8\uAC70\uB098 \uD074\uB798\uC2A4\uB97C \uBA3C\uC800 \uB4F1\uB85D\uD574\uC8FC\uC138\uC694."));
        }
        if (banner === undefined) {
            return (react_1.default.createElement("p", { className: "banner-empty" }, "\uC774 \uD398\uC774\uC9C0\uC758 \uD074\uB798\uC2A4\uAC00 \uBAA8\uB450 \uAC1C\uBCC4 \uC124\uC815(\uB610\uB294 \uC870\uD68C \uC2E4\uD328)\uC774\uB77C \uC804\uCCB4 \uBC30\uB108\uB97C \uD655\uC778\uD560 \uC218 \uC5C6\uC2B5\uB2C8\uB2E4. \uB2E4\uB978 \uD398\uC774\uC9C0\uB85C \uC774\uB3D9\uD558\uAC70\uB098 \uAC80\uC0C9\uC744 \uBC14\uAFD4\uBCF4\uC138\uC694. \uB4F1\uB85D/\uC218\uC815\uC740 \uADF8\uB300\uB85C \uAC00\uB2A5\uD569\uB2C8\uB2E4."));
        }
        if (banner === null) {
            return (react_1.default.createElement("p", { className: "banner-empty" }, "\uC124\uC815\uB41C \uC804\uCCB4 \uBC30\uB108\uAC00 \uC5C6\uC2B5\uB2C8\uB2E4. \uB4F1\uB85D\uD558\uBA74 \uAC1C\uBCC4 \uC124\uC815\uC774 \uC5C6\uB294 \uBAA8\uB4E0 \uD074\uB798\uC2A4\uC5D0 \uB178\uCD9C\uB429\uB2C8\uB2E4."));
        }
        return (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("dl", { className: "banner-fields" },
                react_1.default.createElement("dt", null, "\uC81C\uBAA9"),
                react_1.default.createElement("dd", { title: banner.title }, banner.title),
                react_1.default.createElement("dt", null, "\uC124\uBA85"),
                react_1.default.createElement("dd", { title: banner.description }, banner.description || '-'),
                react_1.default.createElement("dt", null, "\uBC84\uD2BC \uBB38\uAD6C"),
                react_1.default.createElement("dd", null, banner.button_text || '-'),
                react_1.default.createElement("dt", null, "\uBC84\uD2BC \uB9C1\uD06C"),
                react_1.default.createElement("dd", { title: banner.button_link }, banner.button_link || '-')),
            react_1.default.createElement(BannerPreview_1.BannerPreview, { banner: banner, mode: "pc" })));
    };
    const editLabel = banner ? '수정' : banner === null ? '등록' : '등록/수정';
    return (react_1.default.createElement("section", { className: "banner-global-card" },
        react_1.default.createElement("div", { className: "banner-global-head" },
            react_1.default.createElement("p", { className: "banner-section-title" },
                "\uC804\uCCB4 \uBC30\uB108",
                showTenant && tenantId && react_1.default.createElement("span", { className: "banner-tenant" },
                    "\uD30C\uD2B8\uB108 ",
                    tenantId),
                react_1.default.createElement("span", { className: "banner-hint" }, "\uAC1C\uBCC4 \uC124\uC815\uC774 \uC5C6\uB294 \uBAA8\uB4E0 \uD074\uB798\uC2A4 \uD558\uB2E8\uC5D0 \uB178\uCD9C\uB429\uB2C8\uB2E4")),
            react_1.default.createElement("div", { className: "banner-actions" },
                react_1.default.createElement(common_1.Button, { className: "btn-semi-round btn-blue btn-xmd", text: editLabel, onClick: handlerEdit }),
                banner && (react_1.default.createElement(common_1.Button, { className: "btn-semi-round btn-line-peach btn-xmd", text: "\uC0AD\uC81C", onClick: handlerDelete })))),
        renderBody()));
});
/**
 * 배너 관리 목록 — 전체 배너 카드(테넌트별) + 클래스별 배너 상태 표.
 * 서버에 배너 목록 API 가 없어, 클래스 목록(페이지 단위)을 기준으로 클래스마다 GET /banner 를 병렬 조회해
 * 개별 설정 / 전체 배너 적용 / 없음 을 판정한다(페이지당 최대 10건 요청). 전체 배너 카드는 그 결과에서 유도한다.
 */
exports.BannerList = react_1.default.memo(({ searchOption, initPage }) => {
    const userTenantId = (0, react_redux_1.useSelector)((state) => (0, account_1.getUserTenantId)(state));
    const isDefaultAdmin = userTenantId === 'default';
    const [page, setPage] = react_1.default.useState(initPage);
    const [totalCount, setTotalCount] = react_1.default.useState(0);
    const [klasses, setKlasses] = react_1.default.useState([]);
    const [bannerMap, setBannerMap] = react_1.default.useState({});
    // 등록/수정/삭제 후 증가 — 클래스별 조회를 다시 돌린다(전체 카드도 그 결과로 갱신)
    const [version, setVersion] = react_1.default.useState(0);
    const deleteMutation = (0, react_query_1.useMutation)(banner_1.deleteBanner);
    const { data, refetch } = (0, classes_1.useClassesList)({
        title: searchOption,
        offset: page * PAGE_SIZE,
        limit: PAGE_SIZE,
        orderby: 'creation_time DESC',
    });
    const refetchRef = react_1.default.useRef(refetch);
    refetchRef.current = refetch;
    const refetchList = react_1.default.useMemo(() => (0, lodash_1.throttle)(() => refetchRef.current(), 1000), []);
    const bumpVersion = react_1.default.useCallback(() => setVersion(prev => prev + 1), []);
    react_1.default.useEffect(() => {
        setPage(initPage);
    }, [initPage]);
    react_1.default.useEffect(() => {
        refetchList();
    }, [searchOption, page]);
    react_1.default.useEffect(() => {
        const onUpdate = () => {
            bumpVersion();
            refetchList();
        };
        APP.eventManager.subscribe(types_1.UPDATE_BANNER_LIST, onUpdate);
        return () => {
            APP.eventManager.unsubscribe(types_1.UPDATE_BANNER_LIST, onUpdate);
        };
    }, [refetchList, bumpVersion]);
    react_1.default.useEffect(() => {
        if (!data)
            return;
        const { total_count, items, found_count } = data;
        if (total_count > 0 && found_count === 0) {
            const maxPage = Math.max(0, Math.ceil(total_count / PAGE_SIZE) - 1);
            if (page !== maxPage) {
                setPage(maxPage);
                return;
            }
        }
        setKlasses(items ?? []);
        setTotalCount(total_count ?? 0);
    }, [data, page]);
    // 현재 페이지 클래스들의 배너를 병렬 조회
    react_1.default.useEffect(() => {
        if (klasses.length === 0)
            return;
        let cancelled = false;
        setBannerMap(prev => {
            const next = { ...prev };
            klasses.forEach(klass => {
                next[klass.id] = undefined;
            });
            return next;
        });
        Promise.all(klasses.map(klass => (0, banner_1.getBanner)(klass.id)
            .then(response => [klass.id, response?.result ?? null])
            .catch(() => [klass.id, 'error']))).then(entries => {
            if (cancelled)
                return;
            setBannerMap(prev => {
                const next = { ...prev };
                entries.forEach(([id, cell]) => {
                    next[id] = cell;
                });
                return next;
            });
        });
        return () => {
            cancelled = true;
        };
    }, [klasses, version]);
    const rows = react_1.default.useMemo(() => klasses.map(klass => {
        const cell = bannerMap[klass.id];
        if (cell === undefined)
            return { klass, status: 'loading', banner: null };
        if (cell === 'error')
            return { klass, status: 'error', banner: null };
        return { klass, status: (0, types_1.resolveBannerStatus)(klass.id, cell), banner: cell };
    }), [klasses, bannerMap]);
    const isLoadingRows = rows.some(row => row.status === 'loading');
    const globalSummaries = react_1.default.useMemo(() => (0, types_1.summarizeGlobalBanners)(rows), [rows]);
    // 테넌트가 둘 이상 섞여 있거나 default 관리자면 카드에 파트너 ID 를 붙여 구분한다
    const showTenant = isDefaultAdmin || globalSummaries.length > 1;
    const headTitleList = react_1.default.useMemo(() => [
        { title: 'classCode', space: 1 },
        { title: 'className', space: 3 },
        { title: 'subjectName', space: 1 },
        { title: 'bannerStatus', space: 1 },
        { title: 'bannerTitle', space: 3 },
        { title: 'manage', space: 1 },
    ], []);
    const handlerEdit = (row) => {
        openBannerEditor(row.status === 'own' ? 'modify' : 'regist', {
            class_id: row.klass.id,
            class_title: row.klass.title,
            tenant_id: row.klass.tenant_id,
            isNew: row.status !== 'own',
        });
    };
    const handlerDelete = (row) => {
        confirmDeleteBanner('클래스 배너 삭제', `'${row.klass.title}' 클래스의 개별 배너를 삭제하시겠습니까?\n삭제 후에는 전체 배너가 노출됩니다.`, async () => {
            APP.eventManager.publish('SHOW_LOADING', true);
            try {
                await deleteMutation.mutateAsync({
                    class_id: row.klass.id,
                });
                APP.eventManager.publish(types_1.UPDATE_BANNER_LIST);
            }
            catch (err) {
                alert(err);
            }
            finally {
                APP.eventManager.publish('SHOW_LOADING', false);
            }
        });
    };
    const handlerMoreData = (nextPage) => {
        setPage(nextPage);
        APP.eventManager.publish('UPDATE_PAGE', nextPage);
    };
    const renderEmpty = react_1.default.useMemo(() => totalCount <= 0 && (react_1.default.createElement("div", { className: "empty_data" },
        react_1.default.createElement("p", null, "\uB4F1\uB85D\uB41C \uD074\uB798\uC2A4\uAC00 \uC5C6\uC2B5\uB2C8\uB2E4."))), [totalCount]);
    const renderItem = (row) => {
        if (!row)
            return;
        const cells = [
            {
                key: 'identifier',
                space: 1,
                node: react_1.default.createElement("p", { className: "overText2" }, row.klass.identifier),
            },
            {
                key: 'title',
                space: 3,
                node: (react_1.default.createElement("p", { className: "overText2 underline", style: { cursor: 'pointer' }, title: showTenant ? `파트너 ${row.klass.tenant_id}` : undefined, onClick: () => handlerEdit(row) },
                    row.klass.title,
                    showTenant && react_1.default.createElement("span", { className: "banner-tenant inline" }, row.klass.tenant_id))),
            },
            {
                key: 'subject',
                space: 1,
                node: react_1.default.createElement("p", { className: "overText2" }, row.klass.subject),
            },
            {
                key: 'status',
                space: 1,
                node: (react_1.default.createElement("span", { className: `banner-status ${row.status}` }, types_1.BANNER_STATUS_LABEL[row.status])),
            },
            {
                key: 'bannerTitle',
                space: 3,
                node: (react_1.default.createElement("p", { className: "overText2", title: row.banner?.title }, row.banner?.title || '-')),
            },
            {
                key: 'manage',
                space: 1,
                node: (react_1.default.createElement("div", { className: "banner-row-actions" },
                    react_1.default.createElement(common_1.Button, { className: "btn-semi-round btn-blue", 
                        // 전체 배너 적용 중인 클래스에서 저장하면 "개별" 배너가 되어 전체 변경을 따라가지 않는다 — 라벨로 명시
                        text: row.status === 'own' ? '수정' : '개별 등록', onClick: () => handlerEdit(row) }),
                    row.status === 'own' && (react_1.default.createElement(common_1.Button, { className: "btn-semi-round btn-line-peach", text: "\uAC1C\uBCC4 \uC0AD\uC81C", onClick: () => handlerDelete(row) })))),
            },
        ];
        return cells.map(cell => (react_1.default.createElement("div", { key: cell.key, className: "table-item", style: {
                flex: cell.space,
                justifyContent: 'flex-start',
                alignItems: 'center',
                display: 'flex',
                overflow: 'hidden',
            } }, cell.node)));
    };
    return (react_1.default.createElement("div", { className: "banner-admin" },
        globalSummaries.length === 0 ? (react_1.default.createElement(GlobalBannerCard, { summary: null, showTenant: false, loading: isLoadingRows, fallbackTenantId: userTenantId, onChanged: () => APP.eventManager.publish(types_1.UPDATE_BANNER_LIST) })) : (globalSummaries.map(summary => (react_1.default.createElement(GlobalBannerCard, { key: summary.tenantId, summary: summary, showTenant: showTenant, loading: isLoadingRows, fallbackTenantId: userTenantId, onChanged: () => APP.eventManager.publish(types_1.UPDATE_BANNER_LIST) })))),
        react_1.default.createElement("section", { className: "banner-class-section" },
            react_1.default.createElement("p", { className: "banner-section-title" },
                "\uD074\uB798\uC2A4 \uAC1C\uBCC4 \uBC30\uB108",
                react_1.default.createElement("span", { className: "banner-hint" }, "\uAC1C\uBCC4 \uC124\uC815\uC774 \uC788\uB294 \uD074\uB798\uC2A4\uC5D0\uB294 \uC804\uCCB4 \uBC30\uB108 \uB300\uC2E0 \uADF8 \uBC30\uB108\uAC00 \uB178\uCD9C\uB418\uBA70, \uC804\uCCB4 \uBC30\uB108\uB97C \uBC14\uAFD4\uB3C4 \uB530\uB77C\uAC00\uC9C0 \uC54A\uC2B5\uB2C8\uB2E4. \uC804\uCCB4 \uBC30\uB108\uB97C \uB2E4\uC2DC \uB530\uB974\uAC8C \uD558\uB824\uBA74 \uAC1C\uBCC4 \uC0AD\uC81C\uD558\uC138\uC694.")),
            react_1.default.createElement(common_1.Table, { showIndex: true, indexOrder: "desc", isInnerPage: true, isInfinite: false, page: page, data: rows, totalCount: totalCount, headTitleList: headTitleList, renderItem: renderItem, renderEmpty: renderEmpty, handlerMoreData: handlerMoreData }))));
});
